import { Box, Button } from "@mui/material";
import { useState } from "react";

const Expandable = ({ content, minWidth = "250px", contentLimit = 12 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isLongText =
    typeof content === "string" && content.length > contentLimit;

  return (
    <Box
      sx={{
        minWidth: isExpanded ? minWidth : "",
        whiteSpace: !isExpanded ? "nowrap" : "wrap",
      }}
    >
      {isLongText ? (
        <>
          {isExpanded ? (
            <>
              {content}{" "}
              <Button
                onClick={() => setIsExpanded(false)}
                sx={{
                  textTransform: "none",
                  display: "inline",
                  minWidth: 0,
                  fontSize: "10px",
                  padding: 0,
                }}
              >
                less
              </Button>
            </>
          ) : (
            <>
              {content.substring(0, contentLimit) + "..."}
              <Button
                onClick={() => setIsExpanded(true)}
                sx={{
                  textTransform: "none",
                  display: "inline",
                  minWidth: 0,
                  fontSize: "10px",
                  padding: 0,
                }}
              >
                more
              </Button>
            </>
          )}
        </>
      ) : (
        content
      )}
    </Box>
  );
};

export default Expandable;
